import { Component, OnInit, Input } from '@angular/core';
import { PropertyListingService } from '../../../../../shared/providers/property-listing.service';
import { CommonService } from '../../../../../shared/providers/common.service';
import { NewsTickerDetailsModel } from '../../../../../shared/models/NewsTickerDetailsModel';
import { LoaderService } from '../../../../../shared/providers/loader.service';

@Component({
  selector: 'app-credit-profile-profile',
  templateUrl: './credit-profile-profile.component.html'
})
export class CreditProfileProfileTabComponent implements OnInit {

  constructor(private propertyListing: PropertyListingService, private Loader: LoaderService, private commonService: CommonService) { }
  profileData = {} as any;
  profileDetails = {} as any;
  @Input() tickerSymbol = "";
  newsDetail = {} as NewsTickerDetailsModel;
  quote = {} as any;
  ngOnInit() {
    this.Loader.display(true);
    this.getProfileDetails();
  }

  getProfileDetails() {
    this.commonService.GetNewsTickerDetails(this.tickerSymbol, 6103).subscribe(response => {
      if (!response.IsLatestAvailable) {
        this.propertyListing.GetStockProfile(this.tickerSymbol).subscribe(result => {
          if (result != null) {
            this.profileDetails = result;
            this.profileData = this.profileDetails.quoteSummary.result[0]?.assetProfile || null;
            //this.quote = result[0]["quoteType"];
            this.Loader.display(false);
            this.newsDetail.DataJson = JSON.stringify(result);
            this.newsDetail.Ticker = this.tickerSymbol;
            this.newsDetail.TypeId = 6103;
            this.commonService.saveNewsTickerDetail(this.newsDetail).subscribe(data => {
            });

          }
          else {
            this.Loader.display(false);
          }
        });
      }
      else {
        this.profileDetails = JSON.parse(response.DataJson);
        this.profileData = this.profileDetails.quoteSummary.result[0]?.assetProfile || null;
       // this.quote = JSON.parse(response.DataJson)[0]["quoteType"];
        this.Loader.display(false);
      }
    });
  }
}
